import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SurveyCreatePage } from '@apps/web/components/surveys/survey_create_page';
import { useDeepLinkOrganization } from '@apps/web/hooks/use_deep_link_organization';

const surveyCreateSearchSchema = z.object({
    organizationId: z.string().optional(),
    mode: z.enum(['live', 'sandbox']).optional(),
});

export const Route = createFileRoute('/_app/(main)/surveys/create')({
    head: () => ({
        meta: [{ title: 'Create Survey | Phoebe' }],
    }),
    validateSearch: surveyCreateSearchSchema,
    component: SurveyCreateRoute,
});

function SurveyCreateRoute() {
    const { organizationId, mode } = Route.useSearch();
    const { isWaitingForDeepLinkOrganization } = useDeepLinkOrganization(
        organizationId,
        mode,
    );
    return isWaitingForDeepLinkOrganization ? null : <SurveyCreatePage />;
}
